export default {
  "igb": {
    "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])},
    "main-visual": {
      "slogan": {
        "first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["与KUMA一同航向全球宝藏！"])},
        "second": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["为您成功打造终极白标与一站式解决方案。"])}
      },
      "target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Target"])},
      "market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Market"])},
      "ja": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Japan"])},
      "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Latin America"])},
      "es": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "pt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "zh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "userFrontEnd": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["玩家前台介面"])},
      "list": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专属页面设计"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多款推荐模板任你选"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["页面优化设计，提升玩家体验"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HTML5 + 跨装置自适应设计，多语言随时切换"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["20000+ 款热门娱乐游戏，满足各类玩家需求"])}
      ],
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check out the Design Template now"])}
    },
    "boi": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["营运后台系统"])},
      "text": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["提供友善操作介面，同时具备强大功能，满足商户各种营运需求。"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商户可以自行设定网站参数，包含：行销活动、支付方式、游戏交易、客製化管理文案系统（CMS）等功能。"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      ],
      "list": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["报表中心"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["玩家管理"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资金管理"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["游戏管理"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活动促销管理"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["后台内容编辑"])}
      ]
    },
    "advantage": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["核心优势?"])},
      "content": [
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据中心"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["随时监控营运状况，掌握玩家动态与最新趋势。"])},
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据分析"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["营运分析报表"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["营利报表"])}
          ]
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["24/7 全天候支援"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不分时区，任何问题随时找到我们"])},
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["技术支援"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["客服支援"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
          ]
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专业团队支持"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顶尖专业团队，满足您从平台规划到设计运营的所有需求"])},
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一对一专属服务"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["技术开发团队"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专业设计团队"])}
          ]
        }
      ]
    },
    "gameProviders": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["游戏供应商"])}
    },
    "payments": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支付方式"])}
    },
    "process": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["流程说明"])},
      "content": [
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["谘询洽谈 →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["了解您的需求，规划专属方案。"])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合约签订 →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认细节，双方签约合作。"])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["风格设计 →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择模板与设计风格，量身打造您的品牌形象。"])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["网站建置 →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认设计后，开始网站搭建。"])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内容确认与修改 →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["网站完成后，确认细节并进行必要调整。"])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正式上线"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一切就绪，网站正式上线营运！"])}
        }
      ]
    },
    "partner": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合作优势"])},
      "content": {
        "yc": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快速回应"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支持多种加密货币"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["热门游戏不断更新"])}
        ],
        "wc": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["安全可靠"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["简单註册，快速开玩"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多设备完美支援"])}
        ],
        "mc": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["优质玩家体验"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["存提款快速到帐"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["热门优惠活动不间断"])}
        ]
      }
    },
    "googleForm": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["联络我们"])}
    }
  },
  "kb": {
    "eventOverview": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["毎晩19時、勝者には最大30万円相当の賞金チャンス！"])},
      "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["無料で参加できるオンライン対戦イベント。<br/>未経験でも気軽に挑戦できる知的ゲームが、毎晩あなたを待っています。"])}
    },
    "tournamentDetails": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["毎日開催！<br/>戦略を試すトーナメント"])}
    },
    "eventSpecial": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["このイベントが特別な理由"])},
      "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["【TikTokユーザー限定！】初回参加で特別ボーナスプレゼント！"])},
      "mobile": {
        "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["【TikTokユーザー限定！】<br/>初回参加で特別ボーナスプレゼント！"])}
      }
    },
    "howtoJoin": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["参加はとてもシンプル！"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["参加するたびにスキルが上がる！今日の対戦相手は誰になるでしょうか？毎回異なるプレイヤーとの対戦で、新しい戦略や駆け引きを楽しめます。"])}
    },
    "heatedBattle": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["熱闘の瞬間"])},
      "smallTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["「運と実力の絶妙なバランス――知的トーナメント開幕！」"])}
    },
    "growingCommunity": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次の挑戦者はあなた！"])},
      "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登録は簡単！エントリーするだけで、毎晩19時からアツいトーナメントに参加できます！"])}
    }
  },
  "km": {
    "common": {
      "page": {
        "list": {
          "launchSuite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["方案启动"])},
          "systemCenter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["运营中心"])},
          "kumaDna": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMA基因"])},
          "partnerHub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["夥伴赋能"])},
          "smartSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["智能支援"])},
          "language": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["语言"])}
        },
        "subList": {
          "advance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["进阶规划"])},
          "beginner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快速入门"])},
          "custom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["客製专区"])},
          "frontendOverview": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["前台总览"])},
          "backendConsole": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["后台管理"])},
          "gameSetup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["游戏配置"])},
          "KUMAOverview": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMA 概览"])},
          "expoFootprints": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["展会记录"])},
          "partnerBrands": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合作品牌"])},
          "campaignPush": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["行销推播"])},
          "tagStudio": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["标籤工坊"])},
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐私权政策"])}
        }
      },
      "view": {
        "contactBtn": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["联络我们"])}
        },
        "partnerListBtn": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合作品牌"])}
        }
      }
    },
    "component": {
      "CodeTitle": {
        "ThirdBlock": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["从想法"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["到上线"])}
        },
        "FourthBlock": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专业团队"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["核心能力"])}
        },
        "FifthBlock": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合作关系"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专属价值"])}
        },
        "SixthBlock": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["提出问题"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["获得解答"])}
        },
        "Beginner": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品牌升级"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["跨入新階"])}
        },
        "BeginnerInfo": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FAQ 解惑"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["升級更轻松"])}
        },
        "Advance": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快速启动"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["稳定上线"])}
        },
        "AdvanceInfo": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FAQ"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["即刻解惑"])}
        },
        "Custom": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专属打造"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自由成型"])}
        },
        "Frontend": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["前台总览"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清晰掌控"])}
        },
        "Backend": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["后台系统"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集中指挥"])}
        },
        "GameSetup": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["游戏配置"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["策略即刻就绪"])}
        },
        "KUMAOverview": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择 KM"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["强势起步"])}
        },
        "ExpoFootprints": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["走向全球"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扩展影响"])}
        },
        "PartnerBrands": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["严选伙伴"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品质保证"])}
        },
        "CampaignPush": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一键推送"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["直达玩家"])}
        },
        "TagStudio": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["精准呈现"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["亮点聚焦"])}
        }
      },
      "SubTitle": {
        "Beginner": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["优化"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成长"])}
        },
        "Advance": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更简单"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更快速"])}
        },
        "Custom": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["独特"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["稳定"])}
        },
        "Frontend": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["即时洞察"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["决策更快"])}
        },
        "Backend": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据整合"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["决策更快"])}
        },
        "GameSetup": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵活调整"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["页面更亮眼"])}
        },
        "KUMAOverview": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扎实基础"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["智慧成长"])}
        },
        "ExpoFootprints": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["国际视野"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品牌增势"])}
        },
        "PartnerBrands": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["优质供给"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不断进化"])}
        },
        "CampaignPush": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["轻松设定"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["即时传送"])}
        },
        "TagStudio": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多元标签"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵活管理"])}
        }
      },
      "TabCodeSnippet": {
        "getStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开始起步"])},
        "scaleUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扩展升级"])},
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["时间"])},
        "design": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设计"])},
        "update": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更新"])},
        "control": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["控制"])},
        "support": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["支援"])},
        "customization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["客製化"])},
        "integration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["整合"])},
        "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内容管理"])},
        "platform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["平台功能"])},
        "expansion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["功能扩展"])},
        "solutionBtn": {
          "getStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取得解决方案"])},
          "scaleUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["解锁完整潜力"])}
        }
      },
      "PlanCards": {
        "standard": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快速上手"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["即刻启动 轻松部署"])}
        },
        "advanced": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["优化成长"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["性能提升 灵活扩展"])}
        },
        "custom": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵活可靠"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["按需构建 稳定运行"])}
        },
        "viewPlans": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["了解方案"])}
        }
      },
      "StepCards": {
        "activateIdeas": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创意启航"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["启动你的专属品牌"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["从0启程点亮品牌新生"])}
        },
        "blueprintDesign": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打造蓝图"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["挑选网站版型与设定"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多款版型自由组合打造专属风格"])}
        },
        "connectData": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["智能连接"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["整合资料启动进阶"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集成系统模块启动智能流程"])}
        },
        "deployLive": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上线启动"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["测试完成即刻营运"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["测试与优化后，全面启动运营"])}
        }
      },
      "CircleCarousel": {
        "diverseTags": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多元标籤"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["热门/新上/独家标籤任选"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品牌亮点随你自订"])}
          ]
        },
        "flexibleCampaigns": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["弹性活动"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一键发布活动促销s"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["弹性吸引玩家"])}
          ]
        },
        "selfManagedOrdering": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["排序自主"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["游戏随选排序上架"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["平台曝光随时提升"])}
          ]
        },
        "weeklyNewReleases": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["每周上新"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["每週固定上架新游戏"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内容持续更新"])}
          ]
        },
        "exclusiveResources": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专属资源"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["弹性资源管理"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["业界独家仅此一家"])}
          ]
        },
        "controller": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["与 KUMA 合作后才能解锁的专属优势"])}
        }
      },
      "FilesCards": {
        "pricing": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["</费用总览>"])},
          "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["价格如何计算？"])},
          "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["方案灵活，报价清晰，无隐藏费用。"])}
        },
        "timeline": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["</上线时程>"])},
          "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["签约后多久可以上线？"])},
          "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多数项目可在数周内上线，视需求范围而定。"])}
        },
        "checklist": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["</开始准备>"])},
          "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["需要准备哪些资料？"])},
          "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["基础公司信息及必要文件，其余流程由我们协助。"])}
        },
        "filesCardsBtn": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["马上了解详情"])}
        }
      },
      "LetterCards": {
        "clear": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清晰"])},
          "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["指引"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["覆盖全流程"])}
        },
        "custom": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["定制"])},
          "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["方案"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专属你的成长路径"])}
        },
        "curated": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["精选"])},
          "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["服务"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["持续放大价值"])}
        },
        "collaborative": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["协作"])},
          "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["团队"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["共建长期优势"])}
        }
      },
      "KUMAOverview": {
        "coreStrength": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kuma 的核心能力"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMA 的技术底蕴让每一步营运更稳、更快、更准。"])}
        },
        "gamingPlatform": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打造专属品牌博弈平台"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["你的愿景完整实现，每个功能都为营运而设。"])}
        },
        "gamesAndPayments": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一键整合主流游戏与金流"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMA 将游戏与金流安全高效串联，助力全球营运。"])}
        }
      },
      "FsLightGallery": {
        "2025G2E": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2025 G2E"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["展示成熟的系统架构与运营工具，帮助客户快速理解产品价值与应用场景。"])}
        },
        "2025IGB": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2025 IGB"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["以实机展示流程与风控亮点，让客户快速掌握关键价值。"])}
        },
        "2025SIGMA": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2025 SIGMA"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["展示 White Label 及 Turnkey 方案，凸显合作优势，全球询问热度攀升。"])}
        },
        "2024IGB": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2024 IGB"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["分享测试脚本与优化经验，成功降低成本、提升上线效率。"])}
        },
        "2023IGB": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2023 IGB"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["展示即时监控与合规系统，技术与商务现场互动，推动合作升级。"])}
        },
        "2022IGB": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2022 IGB"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["展示 RWD 模板与三步上线流程，吸引大量访客参与，合作机会倍增。"])}
        },
        "2019AWE": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2019 AWE"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["首次亮相亚洲舞台，与伙伴面对面交流，开拓全新国际视野。"])}
        }
      },
      "CampaignPush": {
        "display": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["站内推广整合"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["站内推广整合"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["整合多种站内曝光方式"])}
        },
        "reach": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["流量扩散机制"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["流量扩散机制"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结合代理系统放大推广效益"])}
        },
        "create": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内容自由编辑"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内容自由编辑"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自由编辑内容组合"])}
        },
        "optimize": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成效即时提升"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成效即时提升"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["实时掌握行销成效"])}
        }
      },
      "BrandGallery": {
        "slot": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["老虎机"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["老虎机"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["轻松一按开启转轮，节奏快、内容丰富。"])}
        },
        "live": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["真人"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["真人"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["真人荷官即时互动，轻松体验百家乐、轮盘等桌游。"])}
        },
        "casino": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子游戏"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子游戏"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数位玩法多样，轻松畅玩宾果、赛车等互动游戏。"])}
        },
        "fishing": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["射击/捕鱼"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["射击/捕鱼"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瞄准射击、轻松上手，操作直觉、趣味十足。"])}
        },
        "sports": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["体育"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["体育"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["覆盖全球赛事，实时赔率、玩法刺激易懂。"])}
        },
        "pachinko": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["柏青哥"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["柏青哥"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日式经典娱乐，一按落球，声光效果完整呈现。"])}
        }
      },
      "TagGallery": {
        "hot": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["热门"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["导流人气游戏"])}
        },
        "new": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最新"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保持内容新鲜"])}
        },
        "only": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["独佔"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["强化品牌差异"])}
        },
        "nobonus": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["禁止优惠"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["简化活动管理"])}
        },
        "rebate": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["禁止反水"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["规则清楚透明"])}
        }
      },
      "PrivacyPolicy": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐私权政策"])},
        "subTitle": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["我们尊重您的", _interpolate(_named("privacy")), "，并致力于", _interpolate(_named("protecting")), "您的 ", _interpolate(_named("personalData")), "."])},
        "highlight": {
          "privacy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐私"])},
          "protecting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保护"])},
          "personalData": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个人资料"])}
        },
        "dataCollection": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一、资料收集"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本平台在您使用联络表单、註册询问或其他互动过程中，可能会蒐集您提供的个人资讯，例如姓名、电子邮件、联络方式等。"])}
        },
        "useOfInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二、资料使用"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我们仅收集基本个人资讯，以提供服务与支援。\n您的资料将被安全保存，且仅在取得同意或符合法规时使用。\n我们不会在未经许可的情况下将您的资料提供给第三方。"])}
        },
        "dataProtection": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["三、资料保护"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本平台採取合理的技术与管理措施来保护您的个人资讯，防止未经授权的存取、洩漏、篡改或破坏。"])}
        },
        "dataSharing": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["四、资料分享"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["除非依法规要求或经您同意，本平台不会将个人资料揭露予第三方。但若因平台营运需要，可能会与合作伙伴共享必要资讯，并要求合作方遵守个资保护规范。"])}
        },
        "policyUpdates": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["五、隐私权政策更新"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本平台保留随时修改本政策内容的权利，更新后将立即公告于本页面。建议您定期检阅，以了解最新资讯。"])}
        }
      },
      "KeyCaps": {
        "designer": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#品牌导向"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#模块化模板"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#视觉体系"])}
          ]
        },
        "frontend": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#清晰体验"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#响应式设计"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#内建安全"])}
          ]
        },
        "backend": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#可扩展系统"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#进阶分析"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#风控机制"])}
          ]
        },
        "project": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#定制上线"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#快速交付"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#里程碑清晰"])}
          ]
        },
        "support": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#24/7 service"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Global support"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Human response"])}
          ]
        }
      },
      "Marquee": {
        "launchSuite": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["流程顺畅"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["节奏稳定"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成果明确"])}
          ]
        },
        "systemCenter": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["实时掌控"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据就绪"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["稳定运营"])}
          ]
        },
        "kumaDNA": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["核心稳固"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品牌坚实"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["持续成长"])}
          ]
        },
        "partnerHub": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["内容增强"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["曝光提升"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成效放大"])}
          ]
        },
        "smartSupport": {
          "list": [
            
          ]
        }
      },
      "KumaTitle": {
        "Index": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["专属"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["国际包网平台"])}
        }
      },
      "KumaButton": {
        "exploreSolutions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["探索解决方案"])},
        "bookADemoNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["预约一对一演示"])}
      },
      "IndexBlockSubTitle": {
        "first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["从零到专业。您的愿景，我们步步实现。"])},
        "second": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集结顶尖团队，为您打造专属平台"])},
        "third": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["从概念到上线，将您的蓝图，转化为完美运作的平台"])}
      },
      "PainList": {
        "rows": [
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没经验怕踩雷"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["让资深专家亲自带着你"])}
          },
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不知道怎么开始"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["给你最明确的方向"])}
          },
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信息量太大"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帮你复杂变简单"])}
          },
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["流程繁琐又耗时"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["轻松无痛上手"])}
          },
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["遇到问题找不到人问"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一对一的专属支援"])}
          }
        ]
      },
      "DepartmentCardList": {
        "designer": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#品牌导向"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#模块化模板"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#视觉体系"])}
          ]
        },
        "frontend": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#清晰体验"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#响应式设计"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#内建安全"])}
          ]
        },
        "backend": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#可扩展系统"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#进阶分析"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#风控机制"])}
          ]
        },
        "project": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#定制上线"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#快速交付"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#里程碑清晰"])}
          ]
        },
        "support": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#全天服务"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#跨国支持"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#专人响应"])}
          ]
        }
      },
      "MakeCards": {
        "first": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品牌启航"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["从零开始，确立您的品牌基因"])}
        },
        "second": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["定制风格"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵活搭配模板，打造专属视觉"])}
        },
        "third": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["按需集成"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自由挑选偏好品牌，API 无缝串接由我们负责"])}
        },
        "fourth": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["稳健上线"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["极致性能调优，确保平台状态迎战市场"])}
        }
      },
      "DiceTitle": {
        "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["解答"])},
        "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["疑问"])}
      },
      "FAQList": {
        "first": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["从签约到正式上线需要多久？"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["视项目规模而定，多数项目可于数周内快速上线。"])}
        },
        "second": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["启动项目前我需要准备什么？"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["只需提供基本公司资料与必要文件，我们将全程引导您完成所有流程。"])}
        }
      }
    }
  },
  "kbbak": {
    
  }
}